import React from 'react'
import ReactDOM from 'react-dom'
import StaticChart from './static_chart'

export default function AerodynamicsCharts(props) {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-6 pb-3">
          <StaticChart options={props.windOptions} />
        </div>
        <div className="col-sm-6 pb-3">
          <StaticChart options={props.stabilityOptions} />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <StaticChart options={props.dragOptions} />
        </div>
      </div>
    </React.Fragment>
  );
}
